import React from "react";
//#region types
import { WintSuperkollAPIModelSalary, WintUtilsWebApi } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { Amount } from "models/utilTypes/currencyType";
import { SalaryFormTypes } from "models/formTypes";
import { GossSalaryListViewProps } from "models/propTypes/salaryPropTypes";
import { CommonConstants, FormFieldConstants } from "utils/constants";
//#endregion
//#region components
import { TableAsync, useFilterContext } from "components/common";
import { Profiles } from "components/common";
import { Grid } from "@mui/material";
import { useSalaryService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { DateHelper, LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

const GrossSalaryListView: React.FC<GossSalaryListViewProps> = (props) => {
  const salaryService = useSalaryService();
  const { filter } = useFilterContext<SalaryFormTypes.GrossSalaryFilter>();

  const currentYear = React.useMemo(() => filter?.year ?? DateHelper.getYear(DateHelper.today()), [filter?.year]);

  const filterFunc = React.useCallback(
    (baseFilter: WintUtilsWebApi.Filter) => {
      return salaryService.grossSalaryReportFilter(baseFilter, filter);
    },
    [filter]
  );

  const getProperties = () => {
    const properties = {};
    (properties as any)[`${FormFieldConstants.Salary.GrossSalaryItem.PersonName}`] = {
      description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Employee),
      helpText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.InvoiceDateHelpText),
      formatter: (values: WintSuperkollAPIModelSalary.GrossSalaryListItem) => (
        <Grid container direction="row" spacing={1} alignItems="center" wrap="nowrap">
          <Grid item>
            {values.personId ? (
              <Profiles.UserProfileLink id={values.personId} name={values.personName} />
            ) : (
              UtilsHelper.applyMask(values.identifier ?? "", CommonConstants.PersonNumberMask)
            )}
          </Grid>
        </Grid>
      ),
    };
    const months = [...Array(13).keys()];
    const monthProperties = months.map((i, key) => {
      return {
        description:
          key === 0
            ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Total)
            : `${currentYear}-${key.toString().padStart(2, "0")}`,
        formatter: (values: WintSuperkollAPIModelSalary.GrossSalaryListItem) => {
          const val = values.grossMonthSalaries?.find((v) => v.key === key)?.amount;
          return new Amount(val?.type, val?.value);
        },
        summaryValueFormatter: (values: WintSuperkollAPIModelSalary.GrossSalaryListItem) => {
          const val = values.grossMonthSalaries?.find((v) => v.key === key)?.amount;
          return (
            <Grid container className={cssExports.currencyValue}>
              <Grid container className={cssExports.subValue}>
                {LocalizationHelperInstance.getFormattedCurrency(val?.value ?? 0, val?.type, 2, 2)}
              </Grid>
            </Grid>
          );
        },
        width: 60,
        alignment: "right",
        disableSort: true,
        classification: "amount",
      };
    });
    monthProperties.forEach((mp, index) => {
      (properties as any)[`month${index}`] = mp;
    });

    return properties;
  };

  return (
    <TableAsync
      tableId={props.tableKey}
      properties={getProperties()}
      filter={filterFunc}
      pagination="advanced"
      includeSummary
      maxRowCount={10}
    />
  );
};
export default GrossSalaryListView;
